/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBillAutocompleteSuggestion } from './APIBillAutocompleteSuggestion';
import {
    APIBillAutocompleteSuggestionFromJSON,
    APIBillAutocompleteSuggestionFromJSONTyped,
    APIBillAutocompleteSuggestionToJSON,
} from './APIBillAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIBillAutocompleteResponse
 */
export interface APIBillAutocompleteResponse {
    /**
     * 
     * @type {Array<APIBillAutocompleteSuggestion>}
     * @memberof APIBillAutocompleteResponse
     */
    suggestions: Array<APIBillAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIBillAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIBillAutocompleteResponse interface.
 */
export function instanceOfAPIBillAutocompleteResponse(value: object): value is APIBillAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIBillAutocompleteResponseFromJSON(json: any): APIBillAutocompleteResponse {
    return APIBillAutocompleteResponseFromJSONTyped(json, false);
}

export function APIBillAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBillAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIBillAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIBillAutocompleteResponseToJSON(value?: APIBillAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIBillAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

